import PropTypes from 'prop-types';
import React from 'react';
import {
  Modal,
  ModalButtons,
  ModalContent,
  Button,
  ProgressBar,
  withForm,
  Label,
} from 'mw-style-react';
import { REMOVE_ACTOR_FILTER } from '@control-front-end/common/constants/graphActors';
import useIntl from 'useIntl';
import mes from './intl';
// eslint-disable-next-line no-unused-vars
import sModal from '../../Modal.scss'; // NOSONAR
// eslint-disable-next-line no-unused-vars
import sLocal from './DeleteFilter.scss'; // NOSONAR

function DeleteFilterBase(props) {
  const { visibility, onClose, handleSubmit, isSubmit } = props;
  const t = useIntl();

  return (
    <Modal
      styleName="sModal.modal"
      classes={{ bg: 'modal__overlay' }}
      visibility={visibility}
      onClose={onClose}
      label={t(mes.deleteFilter)}
      size="large"
    >
      <ModalContent styleName="sModal.modal__content sLocal.content">
        <div styleName="sLocal.row">
          <div>
            <Label value={t(mes.warningDelete)} fontWeight="nornmal" />
          </div>
        </div>
      </ModalContent>
      <ModalButtons styleName="sModal.modal__buttons">
        <Button
          id="btnDeleteFilter"
          label={t(mes.buttonDelete)}
          size="large"
          onClick={handleSubmit}
          visibility={isSubmit ? 'disabled' : 'visible'}
        />
        <ProgressBar
          styleName="sModal.modal__loader"
          type="circle"
          size="small"
          visibility={isSubmit ? 'visible' : 'hidden'}
        />
      </ModalButtons>
    </Modal>
  );
}

const DeleteFilter = withForm(
  {
    handleSubmit: (values, dispatch, formActions, props) => {
      formActions.onClose = props.onClose;
      const { data } = props;
      dispatch({
        type: REMOVE_ACTOR_FILTER.REQUEST,
        payload: { ...data },
        formActions,
      });
      if (typeof props.callback === 'function') {
        props.callback();
      }
    },
  },
  DeleteFilterBase
);

DeleteFilterBase.propTypes = {
  visibility: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  dispatch: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
  isSubmit: PropTypes.bool,
  data: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
};

export default DeleteFilter;
